import { DatapointStatus } from 'owa-analytics';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { NotificationCallback, NotificationSubscription } from 'owa-notification';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import SaveToCloudNotificationPayload from 'owa-service/lib/contract/SaveToCloudNotificationPayload';
import { action } from 'satcheljs';

export type ServiceCallFailureCallback = (
    error: string,
    resultCode: AttachmentResultCode,
    datapointStatus: DatapointStatus
) => void;

export type OperationCreatedCallback = (
    operationId: string,
    notificationSubscription: NotificationSubscription,
    notificationCallback: NotificationCallback
) => void;

export type NotificationHandler = (notification: SaveToCloudNotificationPayload) => boolean;

export interface SaveAttachmentsToCloudActionMessage {
    attachmentId: ClientAttachmentId | null;
    itemId: ClientItemId | null;
    notificationHandler: NotificationHandler;
    serviceCallFailureCallback: ServiceCallFailureCallback;
    operationCreatedCallback: OperationCreatedCallback | null;
}

export function saveAttachmentsToCloud(
    attachmentId: ClientAttachmentId,
    itemId: null,
    notificationHandler: NotificationHandler,
    serviceCallFailureCallback: ServiceCallFailureCallback,
    operationCreatedCallback?: OperationCreatedCallback
): SaveAttachmentsToCloudActionMessage;
export function saveAttachmentsToCloud(
    attachmentId: null,
    itemId: ClientItemId,
    notificationHandler: NotificationHandler,
    serviceCallFailureCallback: ServiceCallFailureCallback,
    operationCreatedCallback?: OperationCreatedCallback
): SaveAttachmentsToCloudActionMessage;
export function saveAttachmentsToCloud(
    attachmentId: ClientAttachmentId | null,
    itemId: ClientItemId | null,
    notificationHandler: NotificationHandler,
    serviceCallFailureCallback: ServiceCallFailureCallback,
    operationCreatedCallback: OperationCreatedCallback = null
): SaveAttachmentsToCloudActionMessage {
    return {
        attachmentId: attachmentId,
        itemId: itemId,
        notificationHandler: notificationHandler,
        serviceCallFailureCallback: serviceCallFailureCallback,
        operationCreatedCallback: operationCreatedCallback,
    };
}

export default action('saveAttachmentsToCloud', saveAttachmentsToCloud);
